import { Controller } from '@hotwired/stimulus'

type SelectedPlansType = { [key: string]: string }

// Connects to data-controller="plan-comparison"
export default class extends Controller {
  static targets = [
    'container',
    'plans',
  ]

  declare readonly plansTarget: HTMLDivElement
  declare readonly containerTarget: HTMLDivElement

  connect () {
    this.onConnectSetup()
    document.addEventListener('turbo:frame-render', this.handleTurboReload)
  }

  toggle (e: Event) {
    const el = e.target as HTMLInputElement
    const hiosId = el.id as string
    const planName = el.name as string

    let plans: SelectedPlansType = JSON.parse(sessionStorage.getItem('plans') || '{}')

    if (plans[hiosId]) {
      delete plans[hiosId]
    } else {
      plans = { ...plans, [hiosId]: planName }
    }

    this.appendPlanElements(plans)
    this.updateCheckboxState(plans)

    if (Object.keys(plans).length) {
      this.containerTarget.classList.remove('hidden')
    } else {
      this.containerTarget.classList.add('hidden')
    }

    sessionStorage.setItem('plans', JSON.stringify(plans))
  }

  compare () {
    const plans : SelectedPlansType = JSON.parse(sessionStorage.getItem('plans') || '{}')
    window.location.href = '/public/plan_comparison?plans=' + JSON.stringify(Object.keys(plans))
  }

  clear () {
    const plans: SelectedPlansType = JSON.parse(sessionStorage.getItem('plans') || '{}')

    this.plansTarget.replaceChildren()
    this.updateCheckboxState({})

    Object.keys(plans).forEach((plan: string) => {
      const el = document.getElementById(plan) as HTMLInputElement
      if (el) el.checked = false
    })

    this.containerTarget.classList.add('hidden')

    sessionStorage.setItem('plans', JSON.stringify([]))
  }

  appendPlanElements (plans: SelectedPlansType) {
    this.plansTarget.replaceChildren()

    Object.entries(plans).forEach(([hiosId, planName]) => {
      const planEl = document.createElement('div')
      planEl.id = hiosId + planName
      planEl.innerHTML = planName
      planEl.classList.add('outline', 'outline-1', 'outline-gray-300', 'rounded-md', 'text-center', 'h-6', 'truncate', 'w-0', 'min-w-full', 'px-1', 'pt-1', 'text-xs')
      this.plansTarget.appendChild(planEl)
    })
  }

  handleTurboReload () {
    const plans: SelectedPlansType = JSON.parse(sessionStorage.getItem('plans') || '{}')
    const medicalPlansDiv = document.getElementById('plan_items_list') as HTMLDivElement

    const checkboxes = medicalPlansDiv.querySelectorAll('input[type="checkbox"]')

    checkboxes.forEach((checkbox) => {
      const el = checkbox as HTMLInputElement
      el.checked = Boolean(plans[el.id])
    })
  }

  updateCheckboxState (plans: SelectedPlansType) {
    if (Object.keys(plans).length < 3) {
      this.enableCheckboxes()
    } else {
      this.disableCheckboxes(plans)
    }
  }

  disableCheckboxes (plans: SelectedPlansType) {
    const medicalPlansDiv = document.getElementById('plan_items_list') as HTMLDivElement

    if (Object.keys(plans).length >= 3) {
      const checkboxes = medicalPlansDiv.querySelectorAll('input[type="checkbox"]')

      checkboxes.forEach((checkbox) => {
        const el = checkbox as HTMLInputElement
        const planId = el.id as string

        if (!plans[planId]) {
          el.disabled = true
        }
      })
    }
  }

  enableCheckboxes () {
    const medicalPlansDiv = document.getElementById('plan_items_list') as HTMLDivElement

    const checkboxes = medicalPlansDiv.querySelectorAll('input[type="checkbox"]')

    checkboxes.forEach((checkbox) => {
      const el = checkbox as HTMLInputElement

      el.disabled = false
    })
  }

  onConnectSetup () {
    const plans: SelectedPlansType = JSON.parse(sessionStorage.getItem('plans') || '{}')

    if (Object.keys(plans).length) {
      this.containerTarget.classList.remove('hidden')
    }

    this.appendPlanElements(plans)
    this.updateCheckboxState(plans)

    for (const hoisId of Object.keys(plans)) {
      const checkbox = document.getElementById(hoisId) as HTMLInputElement
      // If checkbox hasn't yet entered the DOM, skip updating the checkbox. The handleTurboReload method will handle properly setting
      // these checkboxes once the plan information enters the DOM.
      if (checkbox) {
        checkbox.checked = true
      }
    }
  }
}
